import {clsx} from 'clsx'

import styles from './Description.module.css'

type DescriptionProps = {
  children: React.ReactNode | string
  className?: string
}

const Description = ({children, className}: DescriptionProps) => {
  if (typeof children === 'string') {
    return (
      <div className={clsx(styles.container, className)}>
        <p className={styles.text}>{children}</p>
      </div>
    )
  }

  return <span className={clsx(styles.container, className)}>{children}</span>
}
Description.displayName = 'Description'

export default Description
